import { defineStore } from "pinia"
import { ToDoItem } from "src/util/types/components/sfxToDoItem"

export interface ToDoItemsStoreType {
  toDoItems: ToDoItem[]
}

export const useToDoItemsStore = defineStore("pinia-todoItemsStore", {
  persist: true,

  state: (): ToDoItemsStoreType => {
    return {
      toDoItems: [],
    }
  },

  actions: {
    deleteDone() {
      this.toDoItems = this.toDoItems.filter((toDoItem: ToDoItem) => !toDoItem.isDone)
    },

    deleteAll() {
      this.$reset()
    },
  },
})
